import { render } from "./YourOrder.vue?vue&type=template&id=2d55514d"
import script from "./YourOrder.vue?vue&type=script&lang=js"
export * from "./YourOrder.vue?vue&type=script&lang=js"

import "./YourOrder.vue?vue&type=style&index=0&id=2d55514d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__